import { DateTime } from "luxon";
import { formatShortCurrency } from "../../components/currency";
import { ApplicationsPipeline, Summary, SummaryRow } from "./Cards";
import { ApplicationStatistics, ApplicationSummaryStatistics } from "./Dashboard";

const numberFormatter = new Intl.NumberFormat("en-US");

export const AccountOpening = ({
  summaryData,
  pipelineData,
}: {
  summaryData: ApplicationSummaryStatistics;
  pipelineData: ApplicationStatistics;
}) => {
  const date = DateTime.now().minus({ days: 30 }).toFormat("MMM dd, yyyy");
  return (
    <div className="margin--bottom--l">
      <h2>Account Opening</h2>
      {summaryData ? (
        <SummaryRow>
          <Summary
            title="Applications opened"
            value={numberFormatter.format(summaryData.opened)}
            change={Number(summaryData.opened_change)}
            changeReferenceDate={date}
          />
          <Summary
            title="Total funding amount"
            value={formatShortCurrency(summaryData.funding_total)}
            change={Number(summaryData.funding_total_change)}
            changeReferenceDate={date}
          />
          <Summary
            title="Average funding amount"
            value={formatShortCurrency(summaryData.average_funding_total)}
            change={Number(summaryData.average_funding_total_change)}
            changeReferenceDate={date}
          />
        </SummaryRow>
      ) : null}
      {pipelineData ? (
        <div className="margin--top--m">
          <ApplicationsPipeline
            steps={[
              {
                name: "Created",
                count: pipelineData.created,
              },
              {
                name: "Submitted",
                count: pipelineData.submitted,
              },
              {
                name: "Funding",
                count: pipelineData.funding,
              },
              {
                name: "Opened",
                count: pipelineData.opened,
              },
            ]}
          />
        </div>
      ) : null}
    </div>
  );
};
